<template>
  <div class="">
    <a-space>
      <!-- <select-day-vue
        :defaultVal="reqPayload.startDate"
        @userDelectDay="selectTime($event, 'startDate')"
      />

      <select-day-vue
        :defaultVal="reqPayload.endDate"
        @userDelectDay="selectTime($event, 'endDate')"
      /> -->

      <select-day-vue
        :defaultVal="reqPayload.localDate"
        @userDelectDay="selectTime($event, 'localDate')"
      />

      <select-range-day
        @userPickRangeTime="userPickRangeTime"
      ></select-range-day>

      <a-select
        v-model:value="reqPayload.questionType"
        style="width: 100px"
        placeholder="问题类型"
        allowClear
        @change="handleSearch"
      >
        <a-select-option value="外观">外观</a-select-option>
        <a-select-option value="功能">功能</a-select-option>
        <a-select-option value="参数">参数</a-select-option>
      </a-select>

      <a-select
        v-model:value="reqPayload.model"
        style="width: 120px"
        placeholder="设备类型"
        allowClear
        @change="handleSearch"
      >
        <a-select-option value="swan 600">swan 600</a-select-option>
        <a-select-option value="swan 600P">swan 600P</a-select-option>
      </a-select>

      <a-select
        v-model:value="reqPayload.status"
        style="width: 100px"
        placeholder="送检状态"
        allowClear
        @change="handleSearch"
      >
        <a-select-option value="合格">合格</a-select-option>
        <a-select-option value="不合格">不合格</a-select-option>
      </a-select>

      <a-input-number
        v-model:value="reqPayload.inspectionFrequency"
        placeholder="送检次数"
        @change="handleSearch"
        allowClear
      />

      <a-input
        v-model:value="reqPayload.search"
        placeholder="搜索"
        @change="handleSearch"
        allowClear
      >
      </a-input>
    </a-space>
  </div>
</template>

<script>
import { defineComponent, reactive } from "vue";
import { timeStampToTime } from "@/utils/index";
import selectRangeDay from "@/components/daypicker/range.vue";
import selectDayVue from "@/views/repairprogress/compoments/selectDay.vue";

export default defineComponent({
  components: {
    selectDayVue,
    selectRangeDay,
  },
  setup(props, context) {
    const reqPayload = reactive({
      questionType: null,
      startDate: null,
      endDate: null,
      model: null,
      inspectionFrequency: null,
      status: null,
      search: null,
      localDate: null,
    });

    const setInitDate = () => {
      reqPayload.localDate = timeStampToTime('', 'upload');
      context.emit("hadleSearch", reqPayload);
    };

    const handleSearch = () => {
      context.emit("hadleSearch", reqPayload);
    };

    const userPickRangeTime = (e) => {
      const [startDate, endDate] = e;
      if (startDate !== "" && endDate !== "") {
        reqPayload.startDate = startDate;
        reqPayload.endDate = endDate;
        reqPayload.localDate = null;
      } else {
        reqPayload.startDate = null;
        reqPayload.endDate = null;
      }
      handleSearch();
    };

    const selectTime = (e, type) => {
      reqPayload[type] = e;
      handleSearch();
    };

    const getSearchData = () => {
      return reqPayload;
    };

    setInitDate();

    return {
      reqPayload,
      selectTime,
      getSearchData,
      handleSearch,
      userPickRangeTime,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
